import React from "react"

import * as clearview from "../../../../components/@Clearview"

export const ExpenseWarningIcon = props => (
	<span hidden={props.expense.warning?.severity === "info"} key={`ewi-${props.expense.id}`} title={props.expense.warning?.message}>
		{clearview.Icon.Severity[props.expense.warning?.severity]}
	</span>
)
